import React, { useState } from "react";
import { setTitle } from "../../../helpers/MetaTag";
import Modal from "../../../components/elements/Modal";
import TrackingDetails from "../../../components/sections/front/User/TrackingDetails";
import TransactionDetails from "../../../components/sections/front/User/TransactionDetails";
import OrderDetailsFiles from "../../../components/sections/front/User/OrderDetailsFiles";
import OrderDetailsAddress from "../../../components/sections/front/User/OrderDetailsAddress";
import OrderDetailsMetaInfo from "../../../components/sections/front/User/OrderDetailsMetaInfo";
import OrderDetailsPrimaryInfo from "../../../components/sections/front/User/OrderDetailsPrimaryInfo";
import CancelOrderModalContent from "../../../components/sections/front/User/CancelOrderModalContent";
import ReturnOrderModalContent from "../../../components/sections/front/User/ReturnOrderModalContent";
import MakePendingPaymentModalContent from "../../../components/sections/front/User/MakePendingPaymentModalContent";
import Dropdown from "../../../components/form/Dropdown";
import Image01 from "../../../assets/images/image-01.webp";
import Image02 from "../../../assets/images/image-02.webp";
import Image03 from "../../../assets/images/image-03.webp";
import Image04 from "../../../assets/images/image-04.webp";
import Image05 from "../../../assets/images/image-05.webp";
import Image06 from "../../../assets/images/image-06.webp";
import Image07 from "../../../assets/images/image-07.webp";
import Image08 from "../../../assets/images/image-08.webp";
import Image09 from "../../../assets/images/image-09.webp";
import Image10 from "../../../assets/images/image-10.webp";
import ConvertedImage01 from "../../../assets/images/converted-01.webp";
import ConvertedImage02 from "../../../assets/images/converted-02.webp";
import ConvertedImage03 from "../../../assets/images/converted-03.webp";
import ConvertedImage04 from "../../../assets/images/converted-04.webp";
import ConvertedImage05 from "../../../assets/images/converted-05.webp";
import ConvertedImage06 from "../../../assets/images/converted-06.webp";
import ConvertedImage07 from "../../../assets/images/converted-07.webp";
import ConvertedImage08 from "../../../assets/images/converted-08.webp";
import ConvertedImage09 from "../../../assets/images/converted-09.webp";
import ConvertedImage10 from "../../../assets/images/converted-10.webp";
import { toast } from "react-toastify";
import useFetch from "../../../hooks/useFetch";
import { useParams } from "react-router-dom";
import { orderDetails } from "../../../services/orderService";
import dayjs from "dayjs";
import OrderDetailImageGallery from "../../../components/single-items/OrderDetailImageGallery";

const OrderDetails = () => {
  const { orderId } = useParams();
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [returnOrderModal, setReturnOrderModal] = useState(false);

  const {
    data: orderDetail,
    error,
    isLoading,
    isFetching,
    updateData,
  } = useFetch({
    dependencies: ["details", orderId],
    fetchFunction: async () => {
      const res = await orderDetails({
        orderId: orderId,
      });
      if (res?.status === 200) {
        return res?.data;
      } else {
        toast.warning(res?.message);
        return {};
      }
    },
  });
  const orderdetails = {
    name: "UI8 Interface Kit",
    description:
      "Get access to a comprehensive design system from UI8's latest release.",
    orderid: "ORD0079249",
    status: "Approved",
    deliverystatus: "Delivered",
    orderdate: "27 May, 2025",
    deliverydate: "3 June, 2025",
    link: "/order/ORD0079249",
    logistics: "Ekart Logistics",
    trackingNo: "TRCK3072637561",
    transactionid: "TXN0095865",
    transactiondate: "27 May, 2025",
    transactionstatus: "Success",
    transactionamount: 29.99,
    file: [
      { filename: "order_001.png", image: Image01 },
      { filename: "order_002.png", image: Image02 },
      { filename: "order_003.png", image: Image03 },
      { filename: "order_004.png", image: Image04 },
      { filename: "order_005.png", image: Image05 },
      { filename: "order_006.png", image: Image06 },
      { filename: "order_007.png", image: Image07 },
      { filename: "order_008.png", image: Image08 },
      { filename: "order_009.png", image: Image09 },
      { filename: "order_001.png", image: Image10 },
    ],
    convertedfile: [
      { filename: "order_001.png", image: ConvertedImage01 },
      { filename: "order_002.png", image: ConvertedImage02 },
      { filename: "order_003.png", image: ConvertedImage03 },
      { filename: "order_004.png", image: ConvertedImage04 },
      { filename: "order_005.png", image: ConvertedImage05 },
      { filename: "order_006.png", image: ConvertedImage06 },
      { filename: "order_007.png", image: ConvertedImage07 },
      { filename: "order_008.png", image: ConvertedImage08 },
      { filename: "order_009.png", image: ConvertedImage09 },
      { filename: "order_001.png", image: ConvertedImage10 },
    ],
  };

  setTitle(`Memory Doddle | Order Details ${orderDetail?.orderId}`);

  const dropdownData = [
    {
      name: "Cancel Order",
      icon: "fa-regular fa-trash-can-xmark",
      click: () => setCancelOrderModal(true),
    },
    {
      name: "Make Payment",
      icon: "fa-regular fa-credit-card",
      click: () => setPaymentModal(true),
    },
    {
      name: "Return Order",
      icon: "fa-regular fa-reply",
      click: () => setReturnOrderModal(true),
    },
    {
      name: "Download Printable Files",
      icon: "fa-regular fa-cloud-arrow-down",
      click: () => {},
    },
    {
      name: "Download Invoice",
      icon: "fa-regular fa-file-invoice",
      click: () => {},
    },
    {
      name: "Help",
      icon: "fa-regular fa-circle-question",
      click: () => {},
    },
  ];

  return (
    <>
      <div className="relative space-y-4 3xl:space-y-5">
        <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
          <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
            <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
              Details of Coloring Book ({orderDetail?.orderId})
            </div>
            <div className="ml-auto flex items-center gap-4">
              <div className="space-y-0.5 flex flex-col items-end">
                <div className="text-[10px] 2xl:text-xs uppercase leading-none text-slate-400 tracking-wide">
                  Order Date
                </div>
                <div className="text-sm 2xl:text-base font-medium leading-none">
                  {dayjs(orderDetail?.createdAt).format("D MMMM, YYYY")}
                </div>
              </div>
              <div className="flex-shrink-0">
                <Dropdown
                  buttonIcon={
                    "fa-solid fa-ellipsis-vertical text-sm text-md-dark"
                  }
                  buttonIconPosition={"left"}
                  buttonArrowIcon={""}
                  xPlacement="bottomRight"
                  buttonClasses="flex items-center justify-center !h-8 !w-8 !p-0"
                  data={dropdownData}
                  dropdownContainer={"!w-52"}
                />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 divide-x divide-md-pink-light-1 -mx-4">
            <div className="px-4">
              <OrderDetailsPrimaryInfo data={orderDetail} />
            </div>
            <div className="px-4 flex">
              <OrderDetailsMetaInfo data={orderDetail} />
            </div>
            <div className="px-4">
              <OrderDetailsAddress data={orderDetail} />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-4 3xl:gap-6 items-start">
          <div className="relative col-span-2">
            {/* <OrderDetailsFiles data={orderdetails} /> */}
            <OrderDetailImageGallery items={orderDetail?.items || []} />
          </div>
          <div className="relative grid grid-cols-1 gap-4">
            <TransactionDetails data={orderdetails} />
            <TrackingDetails data={orderDetail} />
          </div>
        </div>
      </div>
      <Modal
        title={"Cancel Order"}
        size="xl"
        isOpen={cancelOrderModal}
        setIsOpen={() => setCancelOrderModal(false)}
        titleClass={""}
        headerClass={"!bg-black !rounded-t-lg !text-white"}
        childrenClasses={"!rounded-b-lg"}
      >
        <CancelOrderModalContent setModalClose={setCancelOrderModal} />
      </Modal>
      <Modal
        title={"Pending Payments"}
        size="xl"
        isOpen={paymentModal}
        setIsOpen={() => setPaymentModal(false)}
        titleClass={""}
        headerClass={"!bg-black !rounded-t-lg !text-white"}
        childrenClasses={"!rounded-b-lg"}
      >
        <MakePendingPaymentModalContent setModalClose={setPaymentModal} />
      </Modal>
      <Modal
        title={"Return Order"}
        size="xl"
        isOpen={returnOrderModal}
        setIsOpen={() => setReturnOrderModal(false)}
        titleClass={""}
        headerClass={"!bg-black !rounded-t-lg !text-white"}
        childrenClasses={"!rounded-b-lg"}
      >
        <ReturnOrderModalContent setModalClose={setReturnOrderModal} />
      </Modal>
    </>
  );
};

export default OrderDetails;
